import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Model from "@tripian/model";
import { api } from "@tripian/core";
import { FormTemplateResetPassword, ResetPasswordEmail } from "@tripian/react";
import useTranslate from "../../hooks/useTranslate";
import {
  FORGOT_PASSWORD,
  LOGIN,
  NEW_PASSWORD,
} from "../../constants/ROUTER_PATH_TITLE";

const ForgotPasswordPage = () => {
  const [success, setSuccess] = useState<boolean>(false);

  const { t } = useTranslate();

  const navigate = useNavigate();

  document.title = FORGOT_PASSWORD.TITLE(t("auth.forgotPassword.header"));

  const callbackSuccessLogin = (userResetPassword: Model.UserResetPassword) => {
    setSuccess(true);
  };

  return (
    <>
      <div className="full-center-x">
        {success ? (
          <ResetPasswordEmail goBack={() => navigate("/login")} t={t} />
        ) : (
          <>
            <FormTemplateResetPassword
              emailCallBack={email => {
                return api.userResetPassword(
                  email,
                  `${window.location.origin}${NEW_PASSWORD.PATH}/`
                );
              }}
              success={callbackSuccessLogin}
              goBack={() => navigate(LOGIN.PATH)}
              t={t}
            />
          </>
        )}
      </div>
    </>
  );
};

export default ForgotPasswordPage;
